import styled from 'styled-components';

export const AccordionList = styled.ul`
  & > li {
    border-bottom: 1px solid ${({ theme }) => theme.lightGray};
  }
`;

export const AccordionBody = styled.article`
  display: flex;
  flex-direction: column;
`;

export const AccordionHeader = styled.button`
  display: flex;
  align-items: center;
  padding: 18px 20px;
`;

export const AccordionIcon = styled.div`
  width: 26px;
  margin-right: 15px;
  
  font-size: 0;
  text-align: left;
`;

export const AccordionHeading = styled.h3`
  margin: 0;
  padding: 0;
  
  font-size: 14px;
  line-height: 1;
`;

export const AccordionArrow = styled.span`
  transform: ${({ isOpen }) => isOpen ? 'rotate(180deg)' : 'none'};
  margin-left: auto;
  font-size: 0;
  
  svg {
    fill: ${({ theme }) => theme.blue};
  }
`;

export const AccordionContent = styled.div`
  padding: 0 25px;
  padding-top: 5px;
  padding-bottom: 18px;
`;

export const FeaturesList = styled.ul`
  a {
    color: ${({ theme }) => theme.blue};
    
    transition: color 0.3s;
    
    &:hover {
      color: ${({ theme }) => theme.black};
    }
  }
  
  li {
    position: relative;
    
    padding-left: 15px;
    
    font-size: 12px;
    line-height: 16px;
    
    &:not(:last-child) {
      margin-bottom: 10px;
    }
    
    &::before {
      content: "";
      
      position: absolute;
      top: 4px;
      left: 0;
      
      width: 6px;
      height: 6px;
      
      border-radius: 50%;
      background-color: #a8a8a8;
    }
  }
`;
